// Persists an in-progress multi-page scan so an interruption (app switch, camera crash, failed upload)
// never loses the pages already captured. IndexedDB: page images exceed localStorage limits.
const DB = "cc-scans";
const STORE = "sessions";

function open() {
  return new Promise((resolve, reject) => {
    const req = indexedDB.open(DB, 1);
    req.onupgradeneeded = () => req.result.createObjectStore(STORE);
    req.onsuccess = () => resolve(req.result);
    req.onerror = () => reject(req.error);
  });
}

async function tx(mode, fn) {
  const db = await open();
  return new Promise((resolve, reject) => {
    const t = db.transaction(STORE, mode);
    const r = fn(t.objectStore(STORE));
    t.oncomplete = () => resolve(r?.result);
    t.onerror = () => reject(t.error);
  });
}

export const loadScan = (key) => tx("readonly", (s) => s.get(key)).catch(() => null);
export const saveScan = (key, pages) => tx("readwrite", (s) => s.put(pages, key)).catch(() => null);
export const clearScan = (key) => tx("readwrite", (s) => s.delete(key)).catch(() => null);

export async function sha256(blob) {
  const buf = await blob.arrayBuffer();
  const h = await crypto.subtle.digest("SHA-256", buf);
  return Array.from(new Uint8Array(h)).map((b) => b.toString(16).padStart(2, "0")).join("");
}

// Pure page-list operations (unit tested).
export function movePage(pages, i, dir) {
  const j = i + dir;
  if (j < 0 || j >= pages.length) return pages;
  const out = pages.slice();
  [out[i], out[j]] = [out[j], out[i]];
  return out;
}

export function isDuplicatePage(pages, hash, exceptIndex = -1) {
  return pages.some((p, k) => k !== exceptIndex && p.hash === hash);
}

export function readyFileIds(pages) {
  return pages.every((p) => p.fileId) ? pages.map((p) => p.fileId) : null;
}
